import Axios from "axios";
const apiClient = Axios.create({
  baseURL: "https://api.opencagedata.com/geocode/v1",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-type": "application/json"
  }
});

export default {
  async getCityState(position) {
    let lat = 0;
    let lon = 0;
    if (position) {
      lat = position.coords.latitude;
      lon = position.coords.longitude;
    }
    return apiClient.get("/json", {
      params: {
        key: "dcd6002a6ff540c18994b4f197cad30a",
        q: lat + "," + lon,
        pretty: "1",
        no_annotations: "1"
      }
    });
  }
};
